import React from 'react'
import styled from '@emotion/styled'

import { TemplateWrapper } from './TemplateWrapper'
import { DetailedCard } from '@jelly/templates'
import { object, string } from 'prop-types'
import { array } from 'prop-types'

const ContentWrapper = styled.main`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.white};
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 0 auto 4rem;
	padding: 0 1rem;
	max-width: 900px;
	width: 100%;
`
const Title = styled.h1`
	${({ theme }) => theme.fonts.bold};
	color: ${({ theme }) => theme.colors.primary};
	font-size: 2.25rem;
	line-height: 42px;
	text-align: center;

	${({ theme }) => theme.MQ.M} {
		font-size: 2.625rem;
		line-height: 60px;
	}

	${({ theme }) => theme.MQ.XL} {
		font-size: 3.375rem;
	}
`

LeaveBehindOffers.propTypes = {
	meta: object,
	services: array.isRequired,
	title: string,
}

/**
 * Leave Behind Offer page with list of available listings
 *
 * @param {Object} props.meta :: meta data object
 * @param {Array} props.services :: list of available listing services
 * @param {String} props.title :: name of the section
 * @returns
 */
export function LeaveBehindOffers({ meta, services, title }) {
	return (
		<TemplateWrapper meta={meta}>
			<ContentWrapper>
				<Title>{title}</Title>
				{services.map((service, index) => {
					return <DetailedCard key={index} service={service} />
				})}
			</ContentWrapper>
		</TemplateWrapper>
	)
}
